import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=56808eda&"
import script from "./logo.vue?vue&type=script&lang=ts&"
export * from "./logo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports